export function addTrailingSlash(path: string) {
	if (path === '') return '/'

	const start = path.startsWith('/') || path.startsWith('#') ? '' : '/'
	const trailing = path.endsWith('/') || path.startsWith('#') ? '' : '/'

	// Removes duplicated forward slashes [Except for the leading // in htttps://]
	return `${start}${path}${trailing}`.replace(/([^:]\/)\/+/g, '$1')
}
